export default "<style>\n  \n  link--preview\n  {\n    display: none; \n  } \n\n</style>\n\n";